<template>
  <div class="roaming-section">
    <h2 class="title">{{ $t('roamingServicePage.roamingServiceTitle') }}</h2>
    <p class="description">{{ $t('roamingServicePage.roamingServiceDescription.line1') }}</p>
    <p class="description">{{ $t('roamingServicePage.roamingServiceDescription.line2') }}</p>
    <transition name="fade" mode="out-in">
      <loader-with-message v-if="roamingDataLoading"
                           :has-error="roamingDataLoadError"
                           @retry="getRoamingStatus"
                           class="roaming-loader"/>
      <div v-else class="loader-wrapper">
        <div class="switch-wrapper">
          <label>{{ $t('roamingServicePage.switchButtonLabel') }}</label>
          <transition name="fade" mode="out-in">
            <base-inline-loader v-if="dataLoading" :key="'loader'" class="switch-loader"/>
            <switch-button v-else :disabled="changeStatus" :default-state="roamingStatus" @change="changeRoamingStatus"/>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SwitchButton from '@/components/common/switch-button'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import selectionBlockEvents from '@/mixins/selectionBlockEvents'
import LoaderWithMessage from '@/components/common/loader-with-message'

export default {
  name: 'roaming-service',
  components: { LoaderWithMessage, SwitchButton },
  data () {
    return {
      roamingStatus: false,
      dataLoading: false,
      roamingDataLoading: true,
      roamingDataLoadError: false,
      changeStatus: false,
      loaderTimeout: null
    }
  },
  mixins: [errorMessageHandler, selectionBlockEvents],
  props: {
    resourcesData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    getRoamingStatus () {
      const subscriberIdentity = this.$props.resourcesData.subscriberIdentity
      if (subscriberIdentity) {
        this.roamingDataLoading = true
        this.roamingDataLoadError = false
        this.$apiRequest.get(`user/roaming?subscriberIdentity=${subscriberIdentity}`)
          .then(response => {
            if (response.status === 200) {
              this.roamingStatus = response.data
              this.dataLoading = false
              this.roamingDataLoading = false
              this.changeStatus = false
            }
          })
          .catch(e => {
            this.roamingDataLoadError = true
            // this.handleErrorMessage(e.response.data)
          })
          .finally(() => {
            this.$nextTick(() => {
              this.unblockSidebarSelection(false)
            })
          })
      }
    },
    changeRoamingStatus (state) {
      this.roamingStatus = state
      this.loaderTimeout = setTimeout(() => {
        clearTimeout(this.loaderTimeout)
        this.dataLoading = true
      }, 1000)
      this.changeStatus = true
      const subscriberIdentity = this.$props.resourcesData.subscriberIdentity
      this.$apiRequest.post('user/roaming', { subscriberIdentity: subscriberIdentity, activate: this.roamingStatus })
        .then(response => {
          if (response.status === 200) {
            this.getRoamingStatus()
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          clearTimeout(this.loaderTimeout)
          this.dataLoading = false
        })
    }
  },
  mounted () {
    this.getRoamingStatus()
  }
}
</script>

<style lang="scss" scoped>
.roaming-section {
  color: $text;
  padding-top: 2rem;

  .title {
    margin-bottom: 2.4rem;
    font-size: 2.4rem;
    font-weight: normal;
    text-transform: uppercase;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid $form-border-color;
  }

  .description {
    max-width: 100%;
    font-size: 1.4rem;
    color: $light-black;
    line-height: 1.7;

    @media (map_get($breakpoints, sm)) {
      max-width: 42rem;
    }
  }

  .switch-wrapper {
    background: #ffffff;
    padding: 16px;
    border-radius: 5px;
    margin-top: 24px;
    min-width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (map_get($breakpoints, sm)) {
      min-width: 420px;
    }

    label {
      font-weight: 600;
      font-size: 12px;
      color: $light-black;
      line-height: 1.2;

      @media (map_get($breakpoints, sm)) {
        font-size: 14px;
      }
    }
  }

  .loader-wrapper {
    display: flex;
    align-items: center;

    .switch-loader {
      width: auto;
      height: 15px;
      padding-right: 2rem;
    }
  }
}

.roaming-loader {
  padding-top: 0;

  @media (map_get($breakpoints, sm)) {
    max-width: 54rem;
  }
}
</style>
